const map = {
	"./Documents/Dialogs/CreateFolderDialog.razor.js": "./Pages/Documents/Dialogs/CreateFolderDialog.razor.js",
	"./Documents/Dialogs/Export/Settings/DownloadScreen.razor.js": "./Pages/Documents/Dialogs/Export/Settings/DownloadScreen.razor.js",
	"./IconsPage.razor.js": "./Pages/IconsPage.razor.js",
	"./Tasks/ScheduleDialog.razor.js": "./Pages/Tasks/ScheduleDialog.razor.js",
	"./Users/UsersPage.razor.js": "./Pages/Users/UsersPage.razor.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./Pages sync recursive ^.*\\.razor\\.js$";